export default __webpack_public_path__ + "static/media/Password-Generator.161eb8f0.JPG";